const SchoolLevel = {
  PrimarySchool: 1, // Tiểu học
  SecondarySchool: 2, // THCS
  HighSchool: 3, // THPT
  PrimaySecondSchool: 4, // Liên cấp 1, 2
  SecondaryHighSchool: 5, // Liên cấp 2, 3
  PrimaySecondHighSchool: 6 // Liên cấp 1, 2, 3
}

/**
 * Những tool của ckedtor phục phụ cho config
 */
const EditorToolItems = {
  Bold: 'bold',
  Italic: 'italic',
  StrikeThrough: 'strikethrough',
  Underline: 'underline',
  Alignment: 'alignment',
  Vertical: '|',
  Link: 'link',
  Mathtype: 'mathTypeNNAnh',
  File: 'uploadSimulate',
  Table: 'insertTable',
  Media: 'mediaEmbed',
  Undo: 'undo',
  Redo: 'redo'
}

const Enumeration = {
  /** ---------- Base, Control, ... - Begin ---------- */
  // Trạng thái
  EntityState: {
    // Không có trạng thái
    None: 0,

    // Thêm
    Add: 1,

    // Sửa
    Update: 2,

    // Xóa
    Delete: 3,

    // Nhân bản
    Duplicate: 4
  },

  // Các mode của form
  EditMode: {
    // Không xác định
    None: 0,

    // Thêm
    Add: 1,

    // Xem
    View: 2,

    // Sửa
    Edit: 3,

    // Nhân bản
    Duplicate: 4
  },

  // Command của button
  CommandName: {
    // Thêm
    Add: 'Add',
    // Lưu
    Save: 'Save',
    // Lưu và thêm
    SaveAdd: 'SaveAdd',
    // Sửa
    Edit: 'Edit',
    // Xóa
    Delete: 'Delete',
    // Đóng
    Close: 'Close'
  },

  /**
   * Loại combo
   */
  ComboType: {
    Default: 'default',
    Enum: 'enum',
    Data: 'data',
    Demand: 'demand'
  },

  /**
   * kiểu dữ liệu
   */
  DataType: {
    /// <summary>
    /// Chữ
    /// </summary>
    Text: 0,
    /// <summary>
    /// Số
    /// </summary>
    Number: 1,
    /// <summary>
    /// Bool
    /// </summary>
    Boolean: 2,
    /// <summary>
    /// Ngày tháng
    /// </summary>
    Datetime: 3,
    /// <summary>
    /// Guid
    /// </summary>
    Guid: 4,
    /// <summary>
    /// ObjectID
    /// </summary>
    ObjectID: 5,
    /// <summary>
    /// Ngày
    /// </summary>
    Date: 6,
    /// <summary>
    /// Giờ
    /// </summary>
    Time: 7,

    /// <summary>
    /// Kiểu enum
    /// </summary>
    Enum: 100,
    /// <summary>
    /// Kiểu STT
    /// </summary>
    STT: 105
  },

  /**
   * module hệ thống
   */
  ModuleType: {
    Auth: 5,
    Common: 10,
    Question: 15,
    Teacher: 20,
    Student: 25,
    Export: 30
  },

  /**
   * @description enum controller của backend
   */
  ControllerName: {
    ClassRoom: 'classrooms',
    Organization: 'organizations',
    File: 'files',
    Location: 'locations',
    Teacher: 'teachers',
    Student: 'students',
    Grade: 'grades',
    Notify: 'notifies',
    Subject: 'subjects',
    ExerciseStore: 'exercise-stores',
    Topic: 'topics',
    StudentExercise: 'student-exercises',
    StudentEventCalendar: 'student-event-calendar',
    SchoolExamPeriodDetail: 'school-exam-period-details',
    PracticeCourse: 'practice-courses',
    HocMaiCourseDetail: 'course-detail',
    HocMaiCourse: 'courses',
    IGiaoDucCourse: 'igiaoduc-courses'
  },

  FunctionName: {
    SchoolExamPeriodDetail: 'school-exam-period-excel',
    StudentExamPeriodDetail: 'student-detail-excel'
  },

  TextAlign: {
    Right: 0,
    Left: 1,
    Center: 2
  },

  /**
   * Loại tải file excel theo tên
   */
  ErrorExcelType: {
    All_Record: 1,
    Only_Error: 2
  },
  /** ---------- Base, Control, ... - End ---------- */

  /** ---------- Business - Begin ---------- */

  /**
   * Giới tính
   */
  Gender: {
    Female: 0,
    Male: 1
  },

  SubjectCode: {
    DEFAULT: 'DEFAULT',
    DIALI: 'DIALI',
    GDCD: 'GDCD',
    HOAHOC: 'HOAHOC',
    KHTN: 'KHTN',
    LICHSU: 'LICHSU',
    NGUVAN: 'NGUVAN',
    SINHHOC: 'SINHHOC',
    TIENGANH: 'TIENGANH',
    TIENGNGA: 'TIENGNGA',
    TIENGNHAT: 'TIENGNHAT',
    TIENGPHAP: 'TIENGPHAP',
    TIENGTQ: 'TIENGTQ',
    TIENGVIET: 'TIENGVIET',
    TOAN: 'TOAN',
    VATLI: 'VATLI'
  },

  /**
   * Trạng thái chờ duyệt của giáo viên
   */
  ApproveStatus: {
    WaitApprove: 0, // đang chờ
    Approved: 1, // đã duyệt
    Refuse: 2, // từ chối
    Disapprove: 3 // chưa tham gia
  },

  /**
   * trạng thái hoạt động
   */
  InActive: {
    Default: 0, // mặc định
    Active: 1, // đang hoạt động
    StopFollowing: 2 // ngưng theo dõi
  },

  LoginForm: {
    Form: 0, // màn mặc định
    EnterCode: 1, // màn nhập code
    GetAuth: 2, // màn lấy các phương thức nhập mã
    ChooseSchool: 3 // màn chọn trường
  },

  /**
   * tabs của màn login
   */
  LoginTab: {
    Student: 'student', // học sinh
    Teacher: 'teacher' // giáo viên
  },

  /**
   * Các form của luồng quên mật khẩu
   */
  ForgetPasswordForm: {
    Form: 0, // nhập tên tài khoản
    EnterCode: 1, // nhập mã xác thực
    EnterNewPassword: 2, // nhập mật khẩu mới
    Preview: 3, // form xem trước thông tin (dành cho học sinh)
    StudentList: 4, // danh sách học sinh (dành cho học sinh)
    StudentNoPhone: 5
  },

  /**
   * Các form của luồng đăng ký tài khoản
   */
  RegisterForm: {
    AccountForm: 0, // Form nhập thông tin đăng ký
    EnterCode: 1, // Màn nhập code
    GetAuth: 2, // màn lấy các phương thức nhập mã
    Success: 3 // thông báo thành công
  },

  LoginType: {
    Default: 0, /// Login không cần thao tác bổ sung

    FirstLoginDefault: 1, /// Lần đầu đăng nhập tài khoản được cấp phát

    JoinFormalClass: 5 /// Join lớp học chính quy
  },

  // Mã lỗi gửi từ bên misaid
  ErrorCodeMisaID: {
    /// <summary>
    /// Không có lỗi trong trường hợp này
    /// </summary>
    Success: 0,
    /// <summary>
    /// Lỗi xảy ra khi gặp exception
    /// </summary>
    Exception: 10000,
    /// <summary>
    /// Http request không hợp lệ do không có token
    /// </summary>
    TokenEmpty: 1000,
    /// <summary>
    /// Scope ở token không chính xác, không thể truy cập vào API
    /// </summary>
    ScopeInvalid: 1001,
    /// <summary>
    /// Token đã hết hạn
    /// </summary>
    TokenExpired: 1002,
    /// <summary>
    /// Token không hợp lệ
    /// </summary>
    TokenInvalid: 1003,
    /// <summary>
    /// Token bị lỗi, không thể kiểm tra token
    /// </summary>
    TokenError: 1004,
    /// <summary>
    /// Tham số đầu vào của request không hợp lệ
    /// </summary>
    ParamsInvalid: 99,
    /// <summary>
    /// Client không hợp lệ
    /// </summary>
    ClientInvalid: 100,
    /// <summary>
    /// Email hoặc số điện thoại không đúng định dạng
    /// </summary>
    EmailOrPhoneInvalidFormat: 101,
    /// <summary>
    /// Tên đăng nhập hoặc mật khẩu không đúng
    /// </summary>
    UserNameOrPasswordInvalid: 102,
    /// <summary>
    /// Tài khoản này đang bị khóa tạm thời, vui lòng thử lại sau 5 phút
    /// </summary>
    AccountTemporaryLocked: 103,
    /// <summary>
    /// Email chưa được kích hoạt
    /// </summary>
    EmailInactive: 104,
    /// <summary>
    /// Email đã được đăng ký tài khoản
    /// </summary>
    EmailExisted: 105,
    /// <summary>
    /// Số điện thoại chưa được kích hoạt
    /// </summary>
    PhoneInactive: 106,
    /// <summary>
    /// Số điện thoại đã được đăng ký tài khoản
    /// </summary>
    PhoneExisted: 107,
    /// <summary>
    /// Mật khẩu phải có ít nhất 8 kí tự bao gồm kí tự chữ hoa, chữ thường, chữ số và kí tự đặc biệt
    /// </summary>
    AccountInactive: 109,
    /// <summary>
    /// Mã xác nhận không chính xác
    /// </summary>
    OTPInvalid: 111,
    /// <summary>
    /// Số điện thoại hoặc email không tồn tại
    /// </summary>
    EmailOrPhoneNotFound: 112,
    /// <summary>
    /// Không tìm thấy người dùng
    /// </summary>
    AccountNotFound: 113,
    /// <summary>
    /// Mã xác nhận đã được gửi đến {Số điện thoại} .Bạn vui lòng nhập chính xác mã vào ô trên.
    /// </summary>
    OTPSent: 122,
    /// <summary>
    /// Mật khẩu cũ không chính xác
    /// </summary>
    CurentPasswordInvalid: 126,
    /// <summary>
    /// Tạo tài khoản không thành công
    /// </summary>
    CreateAccountFailed: 128,
    /// <summary>
    /// Tạo tài khoản không thành công
    /// </summary>
    PasswordEmpty: 131,
    /// <summary>
    /// Thay đổi mật khẩu thất bại!
    /// </summary>
    ChangePasswordFailed: 133,
    /// <summary>
    /// Thay đổi mật khẩu thành công!
    /// </summary>
    ChangePasswordSuccess: 134,
    /// <summary>
    /// Bạn chỉ được phép lấy mã xác nhận tối đa 3 lần/phút
    /// </summary>
    OTPLimitReached: 144,
    /// <summary>
    /// Bạn đã nhập sai mã xác nhận quá số lần cho phép, vui lòng nhấn 'Gửi lại mã xác nhận' để lấy mã mới
    /// </summary>
    OTPIncorrectLimitReached: 145,
    PhoneNotFound: 179, // Số điện thoại không tồn tại
    EmailNotFound: 178, // Email không tồn tại
    EmailInvalidFormat: 139, // Email không đúng định dạng
    PhoneInvalidFormat: 129 // Số điện thoại không đúng định dạng
  },

  ErrorCodeExternal: {
    // Client không hợp lệ
    ClientInValid: 100,
    // Email hoặc số điện thoại không đúng định dạng
    EmailInValid: 101,
    // Email đã được đăng ký tài khoản
    EmailRegisted: 105,
    // Số điện thoại đã được đăng ký tài khoản
    PhoneNumberRegister: 107,
    // Scope không hợp lệ
    ScopeInValid: 110,
    // Mã xác nhận không chính xác
    CodeInValid: 111,
    // Lỗi tạo mới tài khoản
    ErrorCreateAcc: 128,
    // Bạn đã nhập sai mã xác nhận quá số lần cho phép, vui lòng nhấn 'Gửi lại mã xác nhận' để lấy mã mới
    InputExceed: 145,
    // token provider bên OAuth chưa liên kết với tk misa
    ProviderNotConnect: 301,
    // Tài khoản token provider đã liên kết với 1 tài khoản misaid khác
    ProviderConnectToOtherMisaId: 302,

    // Provider không hợp lệ
    ProviderInValid: 306,
    // Liên kết với Provider thất bại
    ProviderConnectFail: 307,
    // Tài khoản MISA ID đã liên kết với một tài khoản Provider khác ngược ở trên
    MisaIdConnectToOtherProvider: 308,
    // requet thieu token
    RequestMissingToken: 1000,
    // token heest hajn
    TokenExpired: 1002,

    // token ko hợp lệ
    TokenInValid: 1003,

    // ko kiem tra dc token
    TokenNotChecked: 1004,
    // co exception
    Exception: 10000,

    // Ngươi dùng ko tồn tại của misaid
    UserNotExist: 173
  },

  InvalidFieldEnumeration: {
    UserNameEmpty: 0, // Tên đăng nhập ko được trống
    PasswordEmpty: 5, // Mk ko được trống
    ConfirmPasswordEmpty: 10, // Xác nhận mật khẩu không được trống
    CodeEmpty: 15, // Mã xác nhận ko được trống
    FirstNameEmpty: 20, // Họ tên đệm ko được trống
    LastNameEmpty: 25, // Tên ko được để trống
    EmailEmpty: 30,
    PhoneNumberEmpty: 35,
    RegexEmailInValid: 40,
    RegexPhoneNumberVNInValid: 45,
    EmailAndPhoneNumberNotEmptySameTime: 50, // emai và sđt ko được trống cùng lúc
    EmailIsExist: 55, // email đã tồn tại
    PhoneNumberIsExist: 60, // sđt đã tồn tại
    EmailAndPhoneNumberIsExist: 65,
    TokenEmpty: 70,
    UserIdEmpty: 75,
    ContextEmpty: 80,
    OrganizationIDIsEmpty: 85,
    OrganizationIDIsNotExist: 90,
    CatpchaInvalid: 95, // sai mã captcha
    EmailInActive: 100, // email đã tồn tại
    PhoneNumberInActive: 105, // sđt đã tồn tại
    UserNameOrPassInvalid: 110,
    UserNameExist: 115,
    PhoneExist: 120,
    RegisterFail: 125,
    MinLenghtPassword: 130, // lỗi số ký tự của pass dưới 8
    DigitNotExistPassword: 135, // lỗi pass word cần chưa số
    UpperAndLowerNotExistPassword: 140, // lỗi pass cần chứa cả upper lẫn lower
    SessionIdEmpty: 145,
    FullNameEmpty: 150, // Lỗi full name không được trống
    ShowCaptcha: 155, // show captcha
    NewPasswordEmpty: 160, // Mật khẩu mới không được trống
    ConfirmPasswordInvalid: 165, // Mật khẩu xác nhận không khớp
    PasswordInvalid: 170, // Mật khẩu không chính xác
    UserNameInvalid: 175, // Tên đăng nhập không đúng
    UserNameNotFound: 180, // Tên đăng nhập không tồn tại
    CodeIncorrect: 185, // mã xác nhận không chính xác
    ForgotPasswordKeyEmpty: 190, // key quên mật khẩu trống
    ForgotPasswordKeyInvalid: 195, // key quên  mật khẩu không chính xác
    OTPIncorrectLimitReached: 200, // nhập OTP sai quá số lần cho phép
    CaptchaScoreTooLow: 210 // điểm captcha quá thấp
  },

  /**
   * Thời gian show Mask
   */
  TimeShowMask: {
    Default: 50
  },

  /**
   * Trạng thái của lớp học
   */
  ClassroomStatus: {
    Active: true, // Theo dõi
    InActive: false // Ngừng theo dõi - lưu trữ
  },

  /**
   *lấy  bài tập ôn luyện
   */
  PracticeType: {
    ExerciseStore: 1, // từ MISA store
    ConTuHocStore: 2, // Con tự học
    ExerciseReference: 0 // từ  bài tập đã làm
  },
  /**
   * Loại lưu trữ
   */
  StorageType: {
    // Temp
    Temp: 0,

    /// <summary>
    /// Avatar giáo viên
    /// </summary>
    TeacherAvatar: 100,

    /// <summary>
    /// Ảnh lớp
    /// </summary>
    TeacherClass: 101,

    /// <summary>
    /// File upload bài tập
    /// </summary>
    TeacherExam: 105,

    /// <summary>
    /// Avatar học sinh
    /// </summary>
    StudentAvatar: 200,

    /// <summary>
    /// Bài nộp
    /// </summary>
    StudentSubmit: 201,

    /// ảnh hỗ trợ
    CourseFeedback: 205,

    /// <summary>
    /// ảnh được trích rút lưu tại bucket homework-scanner
    /// </summary>
    HWScanner: 300,

    /**
     * File từ google drive
     */
    GDReferenceDocument: 400,

    /**
     * File từ google drive, học sinh nộp bài
     */
    GDSubmitExercise: 405,

    /**
     * File từ comment
     */
    CommentFile: 500
  },

  /**
   * Trạng thái vào lớp của học sinh
   */
  StudentApproveStatus: {
    Pending: 0, // chờ phê duyệt
    Approve: 1, // đã duyệt
    Reject: 2 // Từ chối
  },

  /**
   * Loại bài tập
   */
  ExerciseType: {
    Compose: 0, // Soạn
    Upload: 1, // Tải file
    GameGalactic: 2, // Game chiến binh ngân hà
    Other: 3 // không phải loại nào cả
  },

  /**
   * phân biệt được các màn nào trỏ đến màn làm thử để thực hiện back đúng tới trang trước đó
   */
  ScreenActionType: {
    ScreenListExam: 1, // màn hình danh sách bài kiểm tra
    ScreenCreateExam: 2, // màn hình soạn đề thi
    ScreenCreateExamNonId: 3, // màn hình soạn đề thi do giáo viên tự tổ chức và ko có id
    ScreenCreateExamPeriod: 4, // màn hình soạn đề thi
    ScreenDetailExam: 5 // màn chi tiết bài
  },

  /**
   * phân biệt được các màn nào trỏ đến màn làm thử để thực hiện back đúng tới trang trước đó
   */
  ScreenComposeActionType: {
    ScreenListExam: 1, // màn hình danh sách bài kiểm tra
    ScreenCreateExam: 2, // màn hình soạn đề thi
    ScreenCreateExamNonId: 3, // màn hình soạn đề thi không có id
    ScreenDetailExam: 4
  },

  /**
   * Loại chi tiết bài tập
   */
  ExerciseDetailType: {
    MultiChoice: 1, // trắc nghiệm
    Essay: 2, // tự luận
    UploadAnswer: 3, // tải đáp án
    CantSeeTheAnswer: 4, // không được xem câu trả lời
    Expired: 5 // Đã hết hạn
  },

  /**
   * Loại câu trả lời
   */
  AnswerType: {
    Compose: 0, // Soạn
    Upload: 1 // Tải file
  },

  /**
   * Trạng thái bài tập
   */
  ExerciseStatus: {
    SaveDraft: 0, // Lưu nháp
    Complete: 1, // Hoàn thành
    Correcting: 2, // Đang chấm
    Share: 3, // Chia sẻ
    StopShare: 4 // Ngừng chia sẻ
  },

  /**
   * Trạng thái bài tập
   */
  ExerciseDoneStatus: {
    Did: 0,
    Done: 1
  },

  /**
   * Loại câu hỏi
   */
  QuestionType: {
    Select: 0, // Chọn đáp án
    Yesorno: 1, // Đúng sai
    Fill: 3, // Điền từ
    Pairing: 5, //  Ghép đôi
    Group: 2, // Câu hỏi nhóm
    Essay: 4 // Tự luận
  },

  /**
   * Loại màn hình trong drawer tham khảo học liệu
   */
  LibraryScreenType: {
    ListExercise: 0, // Danh sách học liệu tham khảo
    ExerciseDetail: 1, // Chi tiết học liệu tham khảo
    SelectedQuestions: 2 // Danh sách câu hỏi đã chọn
  },

  /**
   * Loại next câu
   */
  NumberQuestionType: {
    PreviousQuestion: -1, // trở lại câu sau
    StayQuestion: 0, // ở lại câu hiện tại
    NextQuestion: 1 // qua câu kế tiếp
  },

  /**
   * Hình thức gửi đáp án
   */
  SubmitAnswer: {
    AfterFinishExercise: 0, // Ngay sau khi hoàn thành bài
    AfterExpired: 1 // Sau khi hết hạn nộp
  },

  // Có cho HS nộp bù hay không
  IsAllowCompensate: {
    Yes: true, // Có
    No: false // Không
  },

  /**
   * Quy tắc làm tròn điểm
   */
  AroundMarkRule: {
    MarkRoundToOne: 0, // Làm tròn đến 1 điểm
    MarkRoundToZeroDotOne: 1 // làm tròn đến 0,1 điểm
  },

  // Trạng thái bài tập
  StudentExerciseStatus: {
    // Giới thiệu học liệu
    Recommend: 7,
    // Nộp muộn
    LateSubmit: 6,
    // Bài tập tham khảo
    Practice: 5,
    // Bài tập tham khảo
    Refer: 4,
    // Chưa nộp
    YetSubmit: 0,
    // Đã làm
    Done: 3,
    // Đã quá hạn
    Expired: 2,
    // Đã nộp
    Submitted: 1,
    // Tất cả
    All: -1
  },

  // Kiểu dữ liệu
  OptionType: {
    // Kiểu chữ
    Text: 0,
    // Kiểu số
    Number: 1,
    // Kiểu bool
    Boolean: 2,
    // Kiểu ngày tháng
    Datetime: 3,
    // Kiểu Guid
    Guid: 4,
    // Kiểu ObjectID
    ObjectID: 5
  },

  // Giá trị tương ứng với các phím trên bàn phím
  KeyboardCode: {
    ArrowLeft: 37,
    ArrowRight: 39
  },

  //  kiểu xem bài tập của  giáo viên
  PreviewAction: {
    // Xem trước  bài đã soạn
    Preview: 0,
    //  Xem bài đã soạn trong kho
    CompleteStorage: 1,
    // Xem bài đã giao trên màn hình chi tiết
    CompleteClassroom: 2,
    // Xem bài thư viện
    LibraryStorage: 3
  },

  // Trạng thái trên danh sách bài đã giao
  ExerciseCardSearchType: {
    Due: 0, // Còn hạn
    Expired: 1, // Hết hạn
    Waitting: 2, // Chờ giao
    All: 4 // Tất cả
  },
  // Trạng thái sắp xếp trên danh sách bài đã giao
  ExerciseCardSortType: {
    Near: 0,
    Far: 1
  },

  ExercisePath: {
    // xem đáp án bài tập tụ soạn
    ExerciseClass: 0,
    // Xem đáp án bài tập tải lên
    ExerciseUpload: 1,
    // xem đáp án màn hình ôn tập
    ExercisePractice: 2,
    // Xem đáp án bài tập tải lên màn hình ôn luyện
    ExcercisePracticeUpload: 3,
    // Xem đáp án học mãi
    ExerciseHocMai: 4
  },

  // status trả về của bài tập
  statusExercise: {
    refer: 2 // status của loại bài tập tham khảo
  },

  // Tổng quan
  DashBoardOverview: {
    // Tổng quan học sinh
    Student: 0,
    // Tổng quan bài tập
    Exercise: 1,
    // Tổng quan chủ đề
    Topic: 2
  },

  /** Style màu cho từng loại đáp án màn xem bài tập giáo viên học sinh */
  StyleNodeAnswer: {
    Correct: 0, // Đúng
    Fail: 1, // Sai
    NotDone: 2, // Chưa làm
    Done: 3 // Đã làm
  },

  /** Enum dùng để phân biệt là đang ở tab lớp học hay tab bài tập */
  StudentTabView: {
    ClassRoom: 0, // Tab lớp học
    Exercises: 1, // Tab bài tập
    Teacher: 2, // Tab giáo viên
    Practice: 3, // tab ôn luyện
    Reference: 4, // tab bài tập tham khảo tổng
    ReferenceClassroom: 5, // bài tập tham khảo của một lớp
    Dashboard: 6 // Tổng quan
  },

  // Cấp học
  SchoolLevel: {
    ...SchoolLevel
  },

  TabActive: {
    All: -1,
    YetSubmit: 0,
    Submitted: 1,
    Expired: 2,
    Refer: 3
  },

  // Danh sách bài tập v2
  TabActiveV2: {
    NotFinish: 0, // Chưa hoàn thành
    Finished: 1 // Đã hoàn thành
  },

  /**
   * Loại thông báo
   */
  NotifyType: {
    StudentJoinClassroom: 0, // Học sinh tham gia lớp không cần phê duyệt
    StudentRequestJoinClassroom: 5, // Học sinh yêu cầu tham gia lớp
    TeacherApproveStudent: 10, // Giáo viên chấp nhận học sinh vào lớp
    TeacherRefuseStudent: 15, // Giáo viên từ chối học sinh vào lớp
    TeacherKickStudent: 20, // Giáo viên xóa học sinh khỏi lớp
    StudentLeaveClassroom: 25, // Học sinh rời lớp
    TeacherGiveExerciseHasDeadline: 30, // Giáo viên giao bài tập có hạn nộp cho học sinh
    TeacherGiveExerciseIndefinite: 33, // Giáo viên giao bài tập không hạn nộp cho học sinh
    TeacherExtendExercise: 35, // Giáo viên gia hạn bài tập
    TeacherAddReferenceExercise: 37, // Giáo viên Thêm tài liệu tham khảo
    TeacherChangeDeadlineAndReferenceExercise: 38, // Giáo viên Thêm tài liệu tham khảo và gia hạn bài tập
    TeacherRecallExercise: 40, // Giáo viên thu hồi bài tập
    TeacherCorrectExercise: 43, // Giáo viên chữa bài cho học sinh
    StudentSubmitExercise: 45, // Học sinh nộp bài
    StudentQuestionExericse: 50, // Phụ huynh/Học sinh hỏi về bài tập
    TeacherAnswer: 55, // Giáo viên trả lời câu hỏi
    ExerciseExpirationSoon: 60, // Bài tập sắp hết hạn
    ExerciseExpired: 65, // Bài tập đã hết hạn
    StudentIsAddedToClass: 70, // Học sinh được thêm vào lớp
    TeacherStopFollowClass: 75, // Giáo viên ngừng theo dõi lớp
    TeacherDeleteClass: 80, // Giáo viên xóa lớp
    StudentJoinNewClass: 85, // Học sinh được lên lớp
    StudentJoinOldClass: 90, // Học sinh bị lưu ban
    TeacherAddExamPeriod: 100, // Giáo viên tạo bài kiểm tra
    TeacherDeleteExamPeriod: 105, // Giáo viên xóa bài kiểm tra
    TeacherOpenExamPeriod: 110, // Giáo viên mở bài kiểm tra
    TeacherReturnExamResult: 115, // Giáo viên trả kết quả kiểm tra cho học sinh
    TeacherDeleteExamResult: 120, // Giáo viên hủy kết quả kiểm tra
    TeacherSendExamStore: 125, // Giáo viên gửi đề kiểm tra cho hội đồng
    TeacherSendExamResult: 130, // Giáo viên gửi kết quả kiểm tra cho hội đồng
    CouncilAssignToCompose: 135, // Hội đồng phân công soạn đề
    CouncilAssignToMark: 140, // Hội đồng phân công chấm bài
    StudentSubmitExam: 145, // Học sinh nộp bài kiểm tra
    TeacherAddStudentPackage: 150, // Giáo viên cấp thẻ khóa học cho sinh
    UserLikeComment: 200, // Người dùng like bình luận
    TaggedUser: 201, // Người dùng được tag vào 1 bình luận
    ReplyComment: 202, // Bình luận được trả lời
    PlatformNotify: 500, // Thông báo từ bên platform
    ISMACNotify: 501 // Thông báo từ bên ISMAC
  },

  /**
   * Sắp xếp tab Học sinh màn hình tổng quan chi tiết
   */
  RankingSortType: {
    Ranking: 0, // Xếp theo thứ hạng
    StudentName: 1, // Xếp theo tên học sinh
    SubmitRateAsc: 2, // Tỉ lệ nộp bài tăng dần
    SubmitRateDesc: 3, // Tỉ lệ nộp bài giảm dần
    CorrectRateAsc: 4, // Tỉ lệ đúng tăng dần
    CorrectRateDesc: 5 // Tỉ lệ đúng giảm dần
  },

  /**
   * Sắp xếp tab Bài tập màn hình tổng quan chi tiết
   */
  ExerciseSortType: {
    SortWeek: 0, // Xếp theo tuần
    SubmitRateAsc: 2, // Tỉ lệ nộp bài tăng dần
    SubmitRateDesc: 3, // Tỉ lệ nộp bài giảm dần
    CorrectRateAsc: 4, // Tỉ lệ đúng tăng dần
    CorrectRateDesc: 5 // Tỉ lệ đúng giảm dần
  },
  /**
   * Sắp xếp tab Chủ đề màn hình tổng quan chi tiết
   */
  TopicSortType: {
    Program: 0, // Xếp theo phân phối chương trình
    NumberExerciseAsc: 1, // Số bài giao tăng dần
    NumberExerciseDesc: 2, // Số bài giao giảm dần
    CorrectRateAsc: 3, // Tỉ lệ đúng tăng dần
    CorrectRateDesc: 4 // Tỉ lệ đúng giảm dần
  },

  /**
   * thứ hạng khi xếp hạng
   */
  Ranking: {
    Rank1st: 1, // hạng 1
    Rank2nd: 2, // hạng 2
    Rank3d: 3 // hạng3
  },

  /**
   * Loại hành động thêm câu hỏi trong soạn bài của giáo viên
   */
  AddQuestionType: {
    NormalAdd: 1, // Thêm câu bình thường
    OnPreviewQuestionAdd: 2, // Thêm câu khi right click vào câu hỏi preview
    ParentQuestionAdd: 3 // thêm câu hỏi nhóm
  },

  /**
   * Enum dùng để thay đổi nội dung của popup gợi ý sử dụng lớp học đã tạo sẵn
   */
  FormSuggestAvaiableClassroomType: {
    ChoseClassroom: 1,
    SendInvite: 2
  },

  /**
   * Trạng thái chia sẻ
   */
  ShareStatus: {
    Share: 'share',
    Unshare: 'unshare'
  },

  /**
   * Loại tỷ lệ màn hình
   */
  screenType: {
    Desktop: 'desktop',
    Tablet: 'tablet',
    Smtablet: 'smtablet'
  },

  /**
   * Loại đáp án thể hiện trong tài liệu được trích rút
   */
  AnswerTypeExtraction: {
    None: 0, // không có đáp án
    Bold: 1, // Đáp án được tô đậm
    Underlined: 2, // Gạch chân
    EndSentence: 3, // Cuối câu
    EndDocument: 4 // Cuối đề
  },

  /**
   * Giáo viên chữa bài tập
   */
  CorrectionExercises: {
    SaveDraft: 0, // Lưu nháp
    Done: 1 // Hoàn thành
  },

  /**
   * Số lượng bản ghi mặc định của page size
   */
  Pagination: {
    PageSize: 30, // Số bản ghi
    CurrentPage: 1, // page mặc đinh
    PageSizeStudentMission: 4,
    PageSizeDefalt: 9,
    PageSizeShare: 3
  },

  /**
   * Trạng thái của từng đối tác
   */
  ParentIDEnum: {
    HOCMAI: 0, // Học mãi
    MISA: 1, // MISA
    IGIAODUC: 2, // IGiaoDuc
    CONTUHOC: 3 // Con tự học
  },

  /**
   * Trạng thái lỗi
   */
  SupportStatus: {
    All: -1, // Tất cả trạng thái
    Normal: 0, // Không trạng thái (Default)
    Noprocess: 1, // Chưa xử lý
    Processed: 2 // Đã xử lý
  },

  /**
   * mã warning của giao bài
   */
  PassWarning: {
    Success: 0, // không có mã
    WarningEmptyStudent: 20, // cảnh báo học sinh bị trống
    WarningExsistsExercise: 50 // cảnh báo đã giao bài rồi
  },
  ErrorType: {
    Error: 0,
    Warning: 1
  },

  /**
   * Dạng kết quả của bài tập
   */
  ResultType: {
    Correct: 'correct', // kết quả đúng
    False: 'false', // kết quả sai
    Eassy: 'eassy', // kết quả tự luận
    NotDone: 'not-done' // chưa làm
  },

  /**
   * List Step hướng dẫn sử dụng
   * Bắt đầu từ 0
   */
  TourGuideSteps: {
    StepOne: 0,
    StepTwo: 1,
    StepThree: 2,
    StepFour: 3,
    StepFive: 4,
    StepSix: 5,
    StepSeven: 6,
    StepEight: 7,
    StepNine: 8,
    StepTen: 9
  },

  TypeExercise: {
    NewCompose: 0, // Soạn mới
    Download: 1 // tải về
  },

  // Nguồn dữ liệu
  TypeSource: {
    Composed: 0, // Tự soạn
    Library: 1, // Thư viện
    MISAStore: 2 // Từ MISA
  },

  ShareType: {
    Complete: 5, // Đã soạn
    Draft: 4, // Đang soạn
    DoneShared: 2, // Đã chia sẻ
    NoShared: 3, // Chưa chia sẻ
    Library: 1, // Từ thư viện
    ExamShare: 6 // Bài kiểm tra của tôi chia sẻ
  },

  TimePeriod: {
    GeneralExam: 0, // thi tập trung,
    DispersionExam: 1 // thi phân tán
  },

  SchoolTimePeriod: {
    GeneralExam: 0, // thi tập trung,
    DispersionExam: 1 // thi phân tán
  },

  IsSendMark: {
    Yes: true, // Đã gửi điểm
    No: false // Chưa gửi điểm
  },

  /**
   * Chức vụ của giáo viên
   */
  TeacherPosition: {
    Principal: 5, // Hiệu trưởng
    VicePrincipal: 10, // Hiệu phó
    Teacher: 15, // Giáo viên
    Other: 0 // khác
  },

  /**
   * Loại bài kiểm tra
   */
  TypeExam: {
    ExamSchool: 0, // Trường tổ chức
    ExamTeacher: 1, // Giáo viên tổ chức
    ShareExam: 2 // Chia sẻ bài kiểm tra
  },

  AssignType: {
    ClassDelivery: 0, // Giao theo lớp
    ListStudentDelivery: 1 // Giao theo danh sách học sinh
  },

  /**
   * Mức độ câu hỏi
   */
  QuestionLevel: {
    Easy: 0, // Dễ
    Normal: 1, // Bình thường
    Hard: 2 // Khó
  },

  /**
   * Hình thức thể hiện đáp án
   */
  AppearanceType: {
    List: 0, // Xem dạng danh sách
    Single: 1 // Xem dạng từng câu
  },

  LikeLevel: {
    Normal: 0, // Bình thường
    VeryGood: 1 // Rất thích
  },

  /**
   * Loại cảnh cáo kỳ thi
   */
  TypeAlert: {
    AlertLogin: 0, // Login
    AlertChangeTab: 1 // Thoát ra ngoài
  },

  /**
   * Cách nhập điểm
   */
  PointType: {
    PointCoefficient: 0, // Theo hệ số điểm
    PointLadder: 1 // Theo thang điểm
  },
  /**
   * Trạng thái kì kiểm tra
   */
  ExaminationState: {
    All: -1, // Tất cả
    Processing: 0, // Đang diễn ra
    NotOpen: 1, // Chưa diễn ra
    Over: 2, // Đã kết thúc
    WaitingOpenTopic: 4 // Đang chờ mở đề
  },

  /**
   * Trạng thái kì kiểm tra
   */
  ExamStoreStatus: {
    No: 0, // Chưa soạn
    Yes: 1 // đã soạn
  },

  /**
   * Thời gian làm bài kiểm tra (phút)
   */
  ExamTime: {
    Fifteen: 15,
    Thirty: 30,
    FortyFive: 45,
    Sixty: 60,
    Ninety: 90,
    OneHundredAndTwenty: 120
  },

  ExamStatus: {
    MyPost: 1, // Bài của tôi
    AssignComposing: 2, // Phân công soạn
    DotAssignment: 3 // Phân công chấm
  },

  ExamStatusFilter: {
    NotDone: 1, // Chưa hoàn thành
    IsDone: 2 // Đã diễn ra
  },

  CorrectSchoolExamSource: {
    Assignment: 0, // Phân công chấm
    Monitor: 1, // Giám sát
    PreviewModeFromTeacher: 2 // Xem bài làm dạng bài GV tự tổ chức KT
  },

  StudentIsReady: {
    Yes: true, // Học sinh đã sẵn sàng làm bài
    No: false // Học sinh chưa sẵn sàng làm bài
  },

  SubmitExamStatus: {
    Draft: 0, // lưu nháp
    Complete: 1 // Hoàn thành
  },

  ExamViewMode: {
    ViewExamStore: 0, // Xem đề bài
    ViewStudentTask: 1, // Xem bài làm
    ViewResult: 2 // Xem kết quả
  },

  MarkLevel: {
    Excellent: 8,
    Average: 5,
    Bad: 0
  },

  /**
   * Trạng thái chấm bài kiểm tra
   */
  ExamPeriodStatus: {
    All: 1,
    Checked: 2,
    Unchecked: 3
  },

  /**
   * Trạng thái tìm kiếm học sinh trong bài kiểm tra
   */
  StudentExamPeriodStatus: {
    All: -1, // Tìm kiếm tất cả học sinh
    IsJoin: 0, // Tìm kiếm học sinh đã vào làm bài
    NotJoin: 1, // Tìm kiếm học sinh chưa vào làm bài
    Marked: 2, // Tìm kiếm học sinh đã được chấm bài
    NotMark: 3, // Tìm kiếm học sinh chưa được chấm bài
    Submited: 4, // Tìm kiếm học sinh đã nộp bài
    IsReady: 5, // Tìm kiếm học sinh đã sẵn sàng
    NotSubmited: 6 // Tìm kiếm học sinh chưa nộp bài
  },

  /**
   * Trạng thái tìm kiếm học sinh trong bài kiểm tra
   */
  StudentSchoolExamPeriodStatus: {
    All: -1, // Tìm kiếm tất cả học sinh
    IsJoin: 0, // Tìm kiếm học sinh đã vào làm bài
    NotJoin: 1, // Tìm kiếm học sinh chưa vào làm bài
    // Marked: 2, // Tìm kiếm học sinh đã được chấm bài
    // NotMark: 3, // Tìm kiếm học sinh chưa được chấm bài
    Submited: 4, // Tìm kiếm học sinh đã sẵn sàng
    IsReady: 5, // Tìm kiếm học sinh đã nộp bài
    NotSubmited: 6 // Tìm kiếm học sinh chưa nộp bài
  },

  TypeForm: {
    ScreenOne: 1, // component mặc định
    ScreenTow: 2 // component kế tiếp
  },

  ExaminationType: {
    Created: 0, // Tự soạn
    Upload: 1 // Tải lên
  },

  TypeScreenExercise: {
    Knowledge: 1, // Màn củng cố kiến thức
    Practice: 2, // Luyện tập
    Subject: 3 // Theo môn
  },

  SubjectType: {
    Other: 0, // Môn khác
    Maths: 1, // Toán
    Literature: 2, // Ngữ văn
    English: 3 // Tiếng Anh
  },

  /**
   * Trạng thái bài kiểm tra
   */
  ExamState: {
    Submitted: 1, // Đã nộp
    NotSubmitted: 0 // Chưa nộp
  },

  /**
   * Index của các tool trong ckeditor
   */
  EditorToolbarIndex: {
    Bold: 0, // in đậm
    Italic: 1, // in nghiêng
    Underline: 2, // gạch chân
    Mathtype: 8 // mathtype
  },

  /**
   * Ngày trong tuần
   */
  DayInWeek: {
    Monday: 1, // thứ 2
    Tuesday: 2, // thứ 3
    Wednesday: 3, // thứ 4
    Thursday: 4, // thứ 5
    Friday: 5, // thứ 6
    Saturday: 6, // thứ 7
    Sunday: 7 // chủ nhật
  },
  /**
   * Tab Phòng học
   */
  TabMeeting: {
    Meetings: 0, // Tab lịch học
    Schedule: 1 // Tab thời khóa biểu
  },

  /**
   * Thay đổi giá trị đồng thời
   */
  RepeatOption: {
    Single: 0, // một giá trị
    Multiple: 1 // nhiều giá trị
  },

  /**
   * Vùng giá trị
   */
  RepeatType: {
    Begin: 0, // Bắt đầu
    Inside: 1, // Nằm giữa
    End: 2 // Kết thúc
  },

  /**
   * Đánh index màn hình hội đồng tổ chức kiểm tra
   */
  SchoolExamPeriodView: {
    Statistical: 0, // Thống kê
    Monitor: 1, // Giám sát
    CommonInformation: 2, // Thông tin chung
    ExamStore: 6, // Thông tin chung
    AssignMark: 3, // Phân công chấm bài
    ExamTopic: 4, // Đề kiểm tra
    ReOrganizeExam: 5 // Tổ chức kiểm tra bù
  },
  /**
   * Trạng thái cho phép chỉnh sửa kỳ đánh giá theo từng môn
   */
  AllowEditSchoolExamPeriodDetail: {
    UnAllow: 0, // Không được sửa
    EditPartial: 1, // Không được sửa thông tin giáo viên
    EditAll: 2 // Cho phép sửa toàn bộ
  },

  /**
   * Ẩn hiện xem chi tiết của banner
   */
  ActiveViewDetail: {
    Hide: 0,
    Shows: 1
  },

  ComposingStatus: {
    Uncomposed: 0, // Chưa soạn
    Composed: 1 // Đã soạn
  },

  ExerciseStoreType: {
    MyPost: 0, // Của tôi
    ShareSchool: 1, // Chia sẻ của trường,
    TeacherCommunityr: 2 // Tham khảo
  },

  ExerciseStoreTab: {
    Topics: 0, // Đề bài
    Documents: 1 // Bài giảng,
  },

  TabNewTeacher: {
    MyPracticeCard: 0, // thẻ học liệu của tôi
    RatingDetail: 1 // Chi tiết xếp hạng
  },

  ExerciseShareCategory: {
    Share: 0, // Danh sách chia sẻ
    Subject: 1, // Danh sách môn
    Favorite: 2, // Danh sách yêu thích
    Free: 3, // Danh sách bộ đề miễn phí
    MostPopular: 4 // Phổ biến nhất
  },

  ExerciseBanner: {
    BannerDefault: 0, // Banner mặc định
    BannerRanking: 1 // Banner ranking
  },

  ExerciseRanking: {
    NewTeacher: 0, // Giáo viên mới
    TechnologyTeacher: 1, // Giáo viên công nghệ
    PositiveTeacher: 10, // Giáo viên tích cực
    CreativeTeacher: 20, // Giáo viên sáng tạo
    Teacher40: 50 // Giáo viên 4.0
  },

  ExerciseShare: {
    MyShare: 6 // Học liệu của tôi chia sẻ
  },

  ExerciseChoose: {
    CancelAllChoose: 0, // Bỏ chọn tất cả
    AllChoose: 1 // Chọn tất cả
  },

  ClassroomType: {
    ChooseClassroom: 1, // DS lớp học
    ChooseExercise: 2 // DS bài tập
  },

  /**
   * Trạng thái mở lịch học
   */
  DurationStatus: {
    Happenning: 0, // đang diễn ra
    LeftTime: 1 // chưa đến hạn mở đề
  },
  RoleDictionaryKey: {
    // Admin
    Admin: 1,
    // Hiệu trưởng
    HeadMaster: 5,
    // Giáo viên bộ môn
    Teacher: 6,
    // Văn thư
    DocManagement: 7,
    // Cán bộ tin học (IT)
    ITManagement: 11,

    StudentManagement: 12,

    // Giáo viên chủ nhiệm
    HomeroomTeacher: 15,
    // Hiệu phó Cấp I(trường liên cấp)
    ViceHeadMasterElementary: 16,
    // Hiệu phó Cấp II(trường liên cấp)
    ViceHeadMasterJunior: 17,
    // Hiệu phó Cấp III(trường liên cấp)
    ViceHeadMasterSenior: 18,
    // Hội đồng tổ chức

    OrganingCommittee: 50,

    // Quản lý ứng dụng

    ApplicationManager: 67
  },

  /**
   * Phân hệ học trực tuyến
   */
  OnlineMeeting: {
    MSTeams: 0, // microsoft team
    Zoom: 1, // zoom meeting
    GGMeet: 2 // google meet
  },

  /**
   * Mode Thiết lập phòng học
   */
  SetupRoomMode: {
    GettingStarted: 1, // Bắt đầu
    SetupComplete: 2, // thiết lập thành công
    Normal: 3 //
  },

  ExerciseActive: {
    Description: 1, // Mô tả chi tiết,
    ExerciseRefer: 2 // Học liệu liên quan
  },

  /**
   * Lên lịch cho zoom
   */
  ZoomMeetingType: {
    Instant: 1, // Ngay lập tức
    Schedule: 2, // Lên lịch
    RecurringNoFixTime: 3, // Định kỳ nhưng không cố định thời gian
    RecurringFixTime: 8 // Định ký cố định thời gian
  },

  /**
   * Lịch học lặp lại
   */
  ZoomMeetingRecurrentType: {
    Daily: 1, // Hàng ngày
    Weekly: 2, // Hàng tuần
    Monthly: 3 // Hàng tháng
  },

  /**
   * Nguồn học liệu
   */
  SourceTypeCourse: {
    ALL: -1, // Tất cả
    HOCMAI: 1, // Học mãi
    IGIAODUC: 2, // I Giáo dục
    HANHTRANGSO: 3, // Hành trang số
    CONTUHOC: 4, // Con tự học
    EMIS: 0 // Emis
  },

  /**
   * học liệu miễn phí / mất phí
   */
  TakeCharge: {
    All: 0,
    NotFree: 1,
    Free: 2
  },

  ExamStoreType: {
    SourceTry: 1,
    SourceTryMultiple: 2
  },

  /**
   * Đối tác
   */
  ParentIDSupport: {
    HOCMAI: 0,
    MISA: 1,
    IGIAODUC: 2
  },

  /**
   * Tab active học liệu
   */
  TabActiveStudentPractice: {
    AllCourse: 0,
    Learning: 1,
    Care: 2
  },

  /**
   * enum filter học liệu của tôi
   */
  MyCourseStatus: {
    NotYet: 0, // Chưa học
    Learning: 1, // Đang học
    Learned: 2 // Đã học
  },

  LibraryCourseType: {
    All: 0, // Tất cả học liệu
    ConsolidateKnowledge: 1, // Củng cố kiến thức
    Practice: 2 // Luyện tập
  },

  CareFavourite: {
    Care: 1, // Học liệu quan tâm
    Favourite: 2 // Học liệu yêu thích
  },

  /**
   * Trạng thái tìm kiếm bài kiểm tra hội đồng tổ chức
   */
  StatusSchoolExamPeriodFilter: {
    All: -1,
    NotOpen: 1, // Chưa diễn ra
    WaitingOpenTopic: 4, // Đang chờ mở đề
    Processing: 0, // Đang diễn ra
    Over: 2 // Đã kết thúc
  },

  /**
   * Trạng thái Chấm bài kỳ đánh giá
   */
  MarkingProgress: {
    All: -1, // Tất cả
    IsMark: 0, // Đã chấm
    NotMark: 1 // Chưa chấm
  },

  /**
   * Trạng thái Lọc danh sách bài kiểm tra của học sinh
   */
  StudentFilterExamStatus: {
    All: -1, // Tất cả
    NotFinish: 0, // Chưa hoàn thành (chưa diễn ra + đang diễn ra)
    Finished: 1 // Đã hoàn thành
  },

  /**
   * Loại bản ghi chi tiết khóa học
   */
  CourseDetailType: {
    Thematic: 1, // Chuyên đề
    ExamGroup: 2, // Nhóm đề thi
    Lesson: 3, // Bài giảng
    Video: 4, // Video
    Topic: 5 // Topic
  },

  StudentType: {
    Unknow: 0, // Học sinh không xác, không có mã SISAP
    JoinFormalClass: 1, // Học sinh có mã SISAP và tham gia lớp học chính quy
    UnJoinFormalClass: 2 // Học sinh có mã SISAP nhưng chưa tham gia lớp học chính quy
  },

  LinkQuiz: {
    Exist: 1, // Có bài tập
    NotExist: 0 // Không có bài tập
  },

  /**
   * Loại tài khoản phòng học trực tuyến
   */
  AccountMeetingType: {
    Organization: 0, // Tổ chức
    Single: 1 // Cá nhân
  },

  PrintIndex: {
    Default: 0, // Mặc định
    Download: 1, // Tải file
    Print: 2 // In file
  },
  // Học sinh ở màn ôn luyện đang ở tab tham khảo hay tab của tôi
  StudentTabSource: {
    My: 0, // Của tôi
    Reference: 1 // Tham khảo
  },
  // Các dạng bài soạn mới
  ComposeExerciseType: {
    ExtractDataToParagraph: 0, // Tách câu hỏi tự động sử dụng AI (Văn bản)
    MultipleChoice: 1, // Soạn đề trắc nghiệm
    EssayChoice: 2, // Soạn đề tự luận
    newCompose: 3 // Soạn bài mới
  },

  /**
   * Loại sử dụng
   */
  StudentPackageUseType: {
    Trial: 0, // Dùng thử
    RealUse: 1 // Dùng thật
  },

  /**
   * Hình thức mua
   */
  StudentPackageBuyType: {
    SchoolCombo: 0, // Combo của trường
    Retail: 1 // Mua lẻ
  },

  /**
   * Phân quyền xem màn bài tập đã giao
   */
  EditEnableAssign: {
    Enable: 1, // Có thể chỉnh sửa
    NotEnable: 0 // Không thể chỉnh sửa
  },

  /**
   * số cột trong câu hỏi ghép đôi
   */
  PairingAnswerCol: {
    FIRST_COL: 1,
    SECONDS_COL: 2
  },

  /**
   * Type xử lý câu hỏi ghép nối
   */
  HandlePairingAnswerType: {
    Convert: 1, // xử lý để lưu xuống DB
    Revert: 2 // Xử lý data lấy lên từ DB
  },

  /**
   * Subcode được gửi trong request của backend
   */
  SubCode: {
    ExamClosed: 'ExamClosed'
  },

  /**
   * StudentExam Error code
   */
  StudentExamErrorCode: {
    ExamSubmittedEndTime: 60
  },

  /**
   * Style màu đáp án
   */
  AnswersColorStyle: {
    Inner: 0, // Màu nền đáp án
    Outter: 1, // Màu viền đáp án
    Lighter: 2, // Màu đáp án nhạt hơn
    All: 3
  },

  /**
   * Tiến độ
   */
  Progress: {
    Min: 0, // 0%
    Max: 100 // 100%
  },

  /**
   * Điểm bonus game chiến binh thiên hà
   */
  GalacticBonusStatus: {
    // Bonus đúng liên tiếp
    Great: 0,
    // Bonus sai liên tiếp
    Wrong: 1
  },

  /**
   * Thời gian làm từng câu game chiến binh thiên hà
   */
  GameTime: {
    Fifteen: 15,
    Thirty: 30,
    FortyFive: 45,
    Sixty: 60,
    Ninety: 90,
    OneHundredAndTwenty: 120,
    OneHundredAndEighty: 180,
    TwoHundredAndForty: 240,
    ThreeHundred: 300
  },

  /**
   * Loại lỗi để hiện thị lên màn danh sách câu hỏi
   */
  QuestionInvalidType: {
    ContentQuestion: 0, /// Nội dung câu hỏi
    ContentAnswer: 1, /// Nội dung đáp án
    CorrectAnswer: 2, /// Tích chọn án đúng
    ContentGroupQuestion: 3 // Nội dung câu hỏi nhóm
  },

  /**
   * Trạng thái game của học sinh
   */
  StudentGameStatus: {
    // Lưu nháp
    SaveDraft: 0,
    // Hoàn thành
    Complete: 1
  },

  /*
   * Dạng update bài làm của HS phía HĐ
   */
  UpdateType: {
    Update: 1,
    Reset: 0
  },

  ReasonType: {
    /// <summary>
    /// Sản phẩm không đáp ứng nhu cầu
    /// </summary>
    ProductNotGood: 1,

    /// <summary>
    /// Sản phẩm hay bị lỗi
    /// </summary>
    ProductError: 2,

    /// <summary>
    /// Thao tác sử dụng không thuận tiện
    /// </summary>
    UseConvenient: 5,

    /// <summary>
    /// Bảo mật phần mềm kém
    /// </summary>
    SecurityNotGood: 7,

    /// <summary>
    /// Tốc độ xử lý chậm
    /// </summary>
    SlowProcessingSpeed: 6,

    /// <summary>
    /// Dịch vụ tư vấn hỗ trợ khách hàng kém
    /// </summary>
    SupportServiceNotGood: 3,

    /// <summary>
    /// Giá thành cao
    /// </summary>
    HighPrice: 4,

    /// <summary>
    /// Lý do khác
    /// </summary>
    ReasonOther: 0
  },

  /**
   * Các view mode của màn hình tổng quan học sinh
   */
  DashboardViewMode: {
    /**
     * màn tổng quan
     */
    Overview: 0,
    /**
     * màn vinh danh học sinh chăm chỉ
     */
    StudentHardWorking: 1,
    /**
     * màn đánh giá học tập
     */
    StudyEvaluateIndividual: 2
  },

  CommentLevel: {
    LevelOne: 1,
    LevelTwo: 2,
    LevelThree: 3
  },
  Emoji: {
    Default: 0,
    Like: 1,
    Love: 2,
    Haha: 3,
    Wow: 4
  },
  PostType: {
    HOCMAI: 0
  },
  TagUserType: {
    Default: 0
  },

  /**
   * Số lượng sao thưởng cho học sinh
   */
  StarAmount: {
    None: 0,
    One: 1,
    Three: 3
  },

  /**
   * Loại quà
   */
  GiftType: {
    SilverFrame: 0, // Khung đại diện bạc
    GoldFrame: 1, // Khung đại diện vàng
    DiamondFrame: 2, // Khung đại diện kim cương
    SpecialFrame: 3 // Khung đại diện đặc biệt
  },

  /**
   * Loại Thẻ quả tặng học liệu cho giáo viên
   */
  GiftCardType: {
    UsedExerciseStore: 0, // Thẻ Sưu tầm học liệu
    ManagerClassroom: 1, // Thẻ tạo và quản lý lớp học
    ComposeExerciseStore: 2, // Thẻ soạn học liệu
    FavoriteExerciseStore: 3, // Thẻ yêu thích học liệu
    ComposeExamStore: 4 // Thẻ soạn đề thi
  },
  ExerciseStoreSortOption: {
    Popular: 0, // Học liệu phổ biến
    Positive: 1 // Giáo viên tích cực
  },
  TypeSearch: {
    Search: 0, // TÌm kiếm
    ViewMore: 1 // Xem thêm
  },

  ClassType: {
    Formal: 0, // Lớp học chính quy
    Add: 1 // Lớp học thêm
  },

  UserType: {
    Teacher: 1,
    Student: 5
  },

  /**
   * Trạng thái của đơn đăng ký học
   */
  RegistrationFormStatus: {
    Pending: 0, // Chờ thanh toán
    Success: 1, // Thanh toán thành công
    Canceled: 2 // Đã hủy
  },

  /**
   *  Kiểu thông báo thông minh
   */
  NotifySmartType: {
    Star: 1, // Sao đánh giá
    Practice: 2, // Đơn đăng ký học
    FeedBackCourse: 3, // Báo cáo lỗi học liệu được xử lý
    TeacherTraining: 4 // Lịch tập huấn sắp diễn ra của giáo viên
  },

  CartItemType: {
    BuyOneGetOneFree: 0, // Mua gói 2 học liệu (Mua 1 tặng 1)
    BuyOneGetTwoFree: 1, // Mua gói 3 học liệu (Mua 1 tặng 2)
    BuyOne: 2, // Mua 1 học liệu (Kèm 1/2 học liệu khuyến mại)
    BuyTwo: 3, // Mua gói 2 học liệu (Kèm 0/1 học liệu khuyến mại)
    BuyThree: 4 // Giá khuyến mại
  },
  ListCourseType: {
    Selected: 0, // danh sách học liệu đã chọn
    Related: 1, // danh sách học liệu liên quan
    Combo: 2 // Combo
  },

  FeatureCheckRanking: {
    // lớp học
    Classroom: {
      ListClassroom: 'ListClassroom', // danh sách lớp học
      ListStudent: 'ListStudent', // danh sách học sinh
      RepairExercise: 'RepairExercise' // chữa bài
    },

    ListStorage: 'ListStorage', // danh sách học liệu
    Community: 'Community', // cộng đồng học liệu
    Reference: 'Reference', // Tham khảo
    Favourite: 'Favourite', // Yêu thích

    // soạn bài
    ComposeExercise: {
      Compose: 'Compose', // soạn bài
      Extract: 'Extract', // trích rút
      Upload: 'Upload', // Tải đề lên soạn phiếu trả lời
      ManyChoice: 'ManyChoice', // Tải đề lên soạn dạng trắc nghiệm

      // Soạn từng loại câu hỏi
      QuestionType: {
        Essay: 'Essay', // Câu tự luận
        Fill: 'Fill', // Câu điền từ
        // EssayFill: 'EssayFill', // câu điền từ và điền vào chỗ trống
        Group: 'Group', // nhóm,
        Pairing: 'Pairing', // ghép nối
        Mix: 'Mix' // hỗn hợp
      }
    },

    // Soạn game
    ComposeGame: {
      HonorRank: 'HonorRank', // Vinh danh thứ hạng
      GalacticGame: 'GalacticGame' // game chiến binh thiên hà
    },

    OrganizeExam: 'OrganizeExam', // Tự tổ chức kỳ kiểm tra
    ListExam: 'ListExam', // danh sách đề thi

    // Liên kết tài khoản
    AccountLink: {
      Zoom: 'Zoom', // Zoom
      GGMeet: 'GGMeet', // GG Meet
      MSTeamPersonal: 'MSTeamPersonal', // MSTeams Cá nhân
      MSTeamEdu: 'MSTeamEdu' // MS Teams edu
    },

    // Danh sách lịch học sắp tới
    ListScheduleClassroom: 'ListScheduleClassroom'
  },
  ErrorUploadGoogleDriveFile: {
    NotEnoughMemory: 0 // Không đủ bộ nhớ lưu trữ
  },

  // Số học liệu có thể chọn
  AttachedCourseNumber: {
    One: 1,
    Two: 2
  },
  // Nơi click hiển thị danh sách học liệu liên quan HM
  EnableRelatedCourseDisplayPlace: {
    ParentCourse: 0,
    Combo: 1
  },
  // nguồn đi vào giỏ học liệu
  PrevStudentCart: {
    Header: 0, // Vào giỏ học liệu khi click icon giỏ hàng trên header
    Course: 1, // Đi từ một khóa học
    RegisterForm: 2 // Đi từ form đăng ký khóa học hết hạn
  },

  // Cấp độ giáo viên
  TeacherRanking: {
    New: 1,
    Technology: 2,
    Andor: 3,
    Creative: 4,
    FourDotZero: 5
  },
  // Tên router kì kiểm tra tổng quan và kiểm tra bù
  TestPeriodRouterName: {
    AssessmentPeriodOverview: 'AssessmentPeriodOverview', // tổng quan
    CompensatoryTest: 'CompensatoryTest' // kiểm tra bù
  },

  // Phạm vi kì kiểm tra
  SchoolExamPeriodScope: {
    School: 0, // Toàn trường
    Grade: 1, // Khối
    Class: 2, // Lớp
    Student: 3 // Học sinh cụ thể
  },

  // Filter "Xem theo" ở màn chọn học sinh tham gia kỳ thi
  StudentViewByFilter: {
    GradeAndClass: 0, // Khối lớp
    ExamPeriod: 1 // Kỳ kiểm tra
  },

  // Filter "Sắp xếp theo" ở màn chọn học sinh tham gia kỳ thi
  SortByPointFilter: {
    HighToLow: 0, // Cao đến thấp
    LowToHigh: 1 // Thấp đến cao
  },

  // Enum tab active dạng bài tập tải file đề bài
  StudentPreviewFileUpload: {
    Answer: 0, // Lời giải
    Question: 1, // Đề bài
    Document: 2, // Tài liệu
    Assignment: 3 // Bài làm
  },
  SaveDataSchoolExamPeriodDetail: {
    SchoolExamPeriod: 0,
    SchoolExamPeriodDetail: 1
  },

  ExamDetailTab: {
    Monitoring: 0, // Giám sát
    Exam: 1 // kiểm tra
  },

  // Trạng thái kết quả bài tập học sinh đã làm
  StudentFinishedExerciseResultStatus: {
    // Tất cả
    All: -1,
    // Đã có kết quả
    HaveResult: 0,
    // Chưa có kết quả
    NoResult: 1
  },

  ContentError: {
    QuestionWrong: 1,
    AnswerWrong: 2,
    TheAnswerWrong: 3,
    Other: 4
  },

  TypeError: {
    SpellingError: 1,
    GrammaticalError: 2,
    WrongContent: 3,
    Other: 4

  },
  // tab loại bài tập Con Tự Học
  MenuSelfLearning: {
    Overview: 0, // Tổng quan
    PracticeKnowledge: 1, // Ôn luyện kiến thức
    PracticeExam: 2, // Luyện đề thi
    QuestionBank: 3// Ngân hàng câu hỏi
  },
  // Trang trước khi vào màn chi tiết kháo học CTH
  PagePreIntoCTH: {
    Practice: 0, // Luyện tập
    KnowledgeConsolidation: 1, // Củng cố kiến thức
    YourStudyMaterial: 2, // Học liệu của bạn
    FavoriteStudyMaterial: 3, /// Học liệu yêu thích tab quan tâm
    StudyRegistrationForm: 4, // Đơn đăng ký học
    CourseDetailCTH: 5, // Chi tiết khóa học CTH
    MaterialStudying: 6, // học liệu trong tab đang học
    MathSubject: 7, // Môn toán
    EnglishSubject: 8, // Môn Tiếng ANh
    TiengVietSubject: 9, // Môn Tiếng Việt
    TabExplore: 10// Tab Khám phá
  },
  // nguồn mở popup hỗ trợ trong CTH
  SupportPopupType: {
    DoExercise: 0, // làm bài tập
    ViewSolution: 1// Xem lời giải
  },
  // Cách thức kiểm tra bài làm trong CTH,Học Mãi
  WayCheckResultActive: {
    EverySentence: 0, // TỪng câu
    AfterSubmit: 1// Sau khi nộp bài
  },

  /**
  /**
   * Domail cho môi trường dev
   */
  DevDomain: 'http://localhost:8080/'

  /** ---------- Business - End ---------- */
}

export default Enumeration
export { SchoolLevel }
export { EditorToolItems }
